"use client";
import { useInView } from "@ui/lib/useInView";
import dynamic from "next/dynamic";
import { useRef } from "react";
import { ErrorBoundary } from "react-error-boundary";

import type { OrbProps } from "./OrbInternal";
const OrbInternal = dynamic(() => import("./OrbInternal"), { ssr: false });

export default function Orb(props: OrbProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(wrapperRef, { once: true });

  return (
    <ErrorBoundary fallback={null}>
      <div className='relative h-full w-full overflow-hidden rounded-full' ref={wrapperRef}>
        {isInView && <OrbInternal {...props} displayCanvas />}
      </div>
    </ErrorBoundary>
  );
}
